<template>
    <div id="app">
        <PageHeader></PageHeader>
        <FloatBar></FloatBar>
        <router-view></router-view>
        <PageFooter></PageFooter>
    </div>
</template>

<script>
    import PageHeader from "@/components/PageHeader";
    import FloatBar from "@/components/FloatBar";
    import PageFooter from "@/components/PageFooter";

    export default {
        name: 'HelloWorld',
        data() {
            return {
                
            }; 
        },
        props: {
            msg: String  //给组件传递的参数类型
        },

        methods:{
            _isMobile() {
                let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
                return flag;
            },
        },
        mounted(){
            if (this._isMobile()) {
                console.log("手机端");
                //this.$router.replace('/pc');
            } else {
                console.log("pc端");
                //this.$router.replace('/mobile');
            }
        },
        components: { //组件
            PageHeader,
            FloatBar,
            PageFooter,
        },
    }

</script>

<style lang="less">
@import url("./assets/css/icon.less");
@import url("./assets/css/base.less");
@import url("./assets/css/index.less");


::selection {
    background: transparent;
    background: #56a8fe;
    color: #fff;
}

::-webkit-scrollbar {
    width: 8px;
    height: 8px;
    background-color: transparent;
}

::-webkit-scrollbar-track {
    background-color: transparent;
}

::-webkit-scrollbar-thumb {
    border-radius: 100px;
    //background-image: linear-gradient(0deg, rgba(23, 22, 21, 0.5) 5%, rgba(23, 22, 21, 0.5) 50%, rgba(23, 22, 21, 0.5) 95%);
    //background-image: linear-gradient(0deg, rgba(255, 255, 255, 0.5) 5%, rgba(255, 255, 255, 1) 50%, rgba(255, 255, 255, 0.5) 95%);
}

#app {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}

body,
html {
    width: 100%;
    height: 100%;
}

body {
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    font-family: "Avenir", Helvetica, Arial, sans-serif, "hiragino sans gb", "microsoft yahei";
    transform: none;
    background-color: #fff;
}

ul {
    margin: 0px;
    padding: 0px;
}

li {
    list-style-type: none;
}
</style>



// WEBPACK FOOTER //
// src/App.vue